import { normalizeFileUrl } from '../../../utils/normalizeFileUrl';
import {
  BannerLanguage,
  IBanner,
  IBannerImages,
} from '../types/Banner';

const getBannerImageByLanguage = (
  images?: IBannerImages,
  language: BannerLanguage = 'uz'
) => {
  const localizedImage =
    images?.[language] ?? images?.uz ?? images?.ru ?? images?.en;

  return localizedImage ? normalizeFileUrl(localizedImage) : '';
};

export const getBanner = (
  item?: IBanner,
  language: BannerLanguage = 'uz'
) => {
  const fallbackImage = item?.image2 || item?.image;
  const imageByLanguage = getBannerImageByLanguage(item?.images, language);
  const normalizedFallbackImage = fallbackImage
    ? normalizeFileUrl(fallbackImage)
    : '';
  const resolvedImage = imageByLanguage || normalizedFallbackImage;

  return {
    id: item?.id ?? 0,
    title: item?.title ?? '',
    description: item?.description ?? '',
    title_uz: item?.title_uz ?? '',
    description_uz: item?.description_uz ?? '',
    image: resolvedImage,
    imageThumb: item?.imageThumb ? normalizeFileUrl(item.imageThumb) : '',
    category_id: item?.category_id ?? 0,
    button: item?.button ?? false,
    product_id: item?.product_id ?? 0,
    image2: resolvedImage,
    images: item?.images ?? {},
    products: item?.products ?? [],
    link: item?.link ?? '',
    target: item?.target ?? null,
  };
};

export const bannersAdapter = (
  data?: IBanner[],
  language: BannerLanguage = 'uz'
) => data?.map(item => getBanner(item, language)) ?? [];
